import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, } from "react";
export const Button = forwardRef(({ variant, children, icon, className, ...props }, ref) => {
    const btnClass = (() => {
        switch (variant) {
            case "secondary":
                return "btn-secondary";
            case "social":
                return "btn-auth";
            case "link":
                return "btn-link";
            case "primary":
            default:
                return "btn-primary";
        }
    })();
    return (_jsxs("button", { className: `btn ${btnClass} ${className ?? ""}`, ...props, ref: ref, children: [icon && _jsx("span", { children: icon }), _jsx("div", { className: "btn-content", children: children })] }));
});
//# sourceMappingURL=button.js.map